import { ErrorTypes, ApiErrorResponse } from "./types";
import * as Yup from "yup";

interface ErrorResponseWithData {
  response: {
    data: ApiErrorResponse;
  };
}

const errorResponseSchema = Yup.object().shape({
  response: Yup.object()
    .shape({
      data: Yup.object()
        .shape({
          type: Yup.mixed().oneOf(Object.values(ErrorTypes)),
          message: Yup.string().required(),
          details: Yup.mixed().optional(),
        })
        .required(),
    })
    .required(),
});

export function isErrorResponse(err: unknown): err is ErrorResponseWithData {
  return errorResponseSchema.isValidSync(err);
}
